/**
 * Get the origin event ID for feature storage.
 * Features are stored centrally per origin event and shared across all modes.
 * Copied events have independent storage (their origin is themselves).
 */
export function getOriginEventId(event?: { id?: string; origin?: string | { id: string } }): string | undefined {
  if (!event) return undefined;
  const origin = event.origin as string | { id: string } | undefined;
  if (!origin) return event.id;
  return typeof origin === 'string' ? origin : origin.id;
}
